var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityUserTime = function SvgSecurityUserTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.993 1.487 3.667 2.733C2.9 3.02 2.273 3.927 2.273 4.747V9.7c0 .787.52 1.82 1.154 2.293l2.866 2.14c.94.707 2.487.707 3.427 0l2.867-2.14c.633-.473 1.153-1.506 1.153-2.293V4.747c0-.82-.627-1.727-1.393-2.014L9.02 1.487c-.567-.207-1.473-.207-2.027 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.667,
    d: "M10 8a2 2 0 1 1-4.001-.001A2 2 0 0 1 10 8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.667,
    d: "m8.742 8.636-.62-.37a.44.44 0 0 1-.196-.344v-.82"
  })));
};
export default SvgSecurityUserTime;